import React, { useState } from "react";
import { useAnimationFrame } from "framer-motion";
/* data imports */
import { wheelData, wheelBasketImages } from "../data/wheelData";

const GiantWheel = ({ handleCabinClick }) => {
  const [rotation, setRotation] = useState(0);

  useAnimationFrame((t) => {
    const r = (t / 1000) * (360 / 60); // 360 degrees per 60 sec
    setRotation(r % 360);
  });

  const wheelSize = (window.innerWidth * 30) / 100;
  const cartSize = (wheelSize * 20) / 100;
  const offset = 0;
  const radius = wheelSize / 2 + offset;
  const center = wheelSize / 2;

  return (
    <div className="giant-wheel-main-wrapper">
      {/* Rotating wheel base */}
      <div
        className="wheel-base"
        style={{
          transform: `rotate(${rotation}deg)`,
        }}
      />

      {/* Carts orbiting independently */}

      {wheelData.map((cart, i) => {
        const baseAngle = (360 / wheelData.length) * i;
        const currentAngle = (baseAngle + rotation) % 360;
        const rad = (currentAngle * Math.PI) / 180;
        const x = center + radius * Math.cos(rad);
        const y = center + radius * Math.sin(rad);

        return (
          <div
            key={cart.id}
            className="wheel-cabin"
            style={{
              left: x,
              top: y,
              width: cartSize,
            }}
          >
            <div
              className="wheel-cabin-inner"
              onClick={() => handleCabinClick(i)}
            >
              <img src={wheelBasketImages[wheelData[i]?.name]} alt="" />
            </div>
          </div>
        );
      })}

      {/* Modal */}
    </div>
  );
};

export default GiantWheel;
